export default {
  "adminHeader.title": "Add users & set roles",
};
